import { getApiUrl } from '@utils/apiUrl';

// Dev/QA and production are SEPARATE stores. A spec created in one does not exist in the other,
// and the form gives no other clue which one it is writing to — same screen, same specs, same
// names. So it says so, on screen, before the button that writes.

export const writeTarget = () => {
  const url = String(getApiUrl() || '');
  let host = url;
  try {
    host = new URL(url).host;
  } catch (e) {
    host = url.replace(/^https?:\/\//, '');
  }
  const isProduction = /^api\./.test(host);
  return { host, isProduction, label: isProduction ? 'Production' : 'Dev / QA' };
};
